import type { StyleProp } from '@vtex/admin-ui'
import {
  ModalHeader,
  Modal,
  ModalContent,
  useModalState,
  csx,
  ModalDismiss,
  ModalTitle,
} from '@vtex/admin-ui'
import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useLocation } from 'react-router'

import { IndevaIFrame } from '../../../../core/components/IndevaIFrame'

const modalStyles: StyleProp = {
  height: '100vh',
  width: 'full',
  maxHeight: 'full',
  margin: 0,
  flex: 1,
  borderWidth: '0px',
  borderRadius: '0px',
}

type GoalsIframeModalProps = {
  salesAssociateId: string
}

export const GoalsIframeModal = ({
  salesAssociateId,
}: GoalsIframeModalProps) => {
  const intl = useIntl()
  const location = useLocation()
  const modalState = useModalState({
    open: location.hash.includes('#/sales-associate-goals'),
  })

  const goalsReportPath = `sellers/${salesAssociateId}`
  const history = useHistory()

  const handleCloseClick = () => {
    modalState.hide()
    history.push('/turn-list')
  }

  return (
    <Modal
      state={modalState}
      hideOnEscape={false}
      hideOnInteractOutside={false}
      aria-label={intl.formatMessage({ id: 'goalsReportModalAriaLabel' })}
      className={csx({ ...modalStyles })}
    >
      <ModalHeader>
        <ModalTitle>{intl.formatMessage({ id: 'individualGoal' })}</ModalTitle>
        <ModalDismiss onClick={handleCloseClick} />
      </ModalHeader>

      <ModalContent className={csx({ height: 'full' })}>
        <IndevaIFrame path={goalsReportPath} />
      </ModalContent>
    </Modal>
  )
}
